var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_3256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0312 2.34065L14.4094 2.71877C14.7031 3.01252 14.7031 3.48752 14.4094 3.77815L13.5 4.69065L12.0594 3.25002L12.9688 2.34065C13.2625 2.0469 13.7375 2.0469 14.0281 2.34065H14.0312ZM6.80625 8.50627L11 4.3094L12.4406 5.75002L8.24375 9.94378C8.15313 10.0344 8.04062 10.1 7.91875 10.1344L6.09062 10.6563L6.6125 8.82815C6.64688 8.70627 6.7125 8.59377 6.80312 8.50315L6.80625 8.50627ZM11.9094 1.28127L5.74375 7.44377C5.47188 7.71565 5.275 8.05002 5.17188 8.41565L4.27812 11.5406C4.20312 11.8031 4.275 12.0844 4.46875 12.2781C4.6625 12.4719 4.94375 12.5438 5.20625 12.4688L8.33125 11.575C8.7 11.4688 9.03438 11.2719 9.30313 11.0031L15.4688 4.84065C16.3469 3.96252 16.3469 2.53752 15.4688 1.6594L15.0906 1.28127C14.2125 0.403149 12.7875 0.403149 11.9094 1.28127ZM3 2.50002C1.48125 2.50002 0.25 3.73127 0.25 5.25002V13.75C0.25 15.2688 1.48125 16.5 3 16.5H11.5C13.0188 16.5 14.25 15.2688 14.25 13.75V10.25C14.25 9.8344 13.9156 9.50002 13.5 9.50002C13.0844 9.50002 12.75 9.8344 12.75 10.25V13.75C12.75 14.4406 12.1906 15 11.5 15H3C2.30938 15 1.75 14.4406 1.75 13.75V5.25002C1.75 4.5594 2.30938 4.00002 3 4.00002H6.5C6.91563 4.00002 7.25 3.66565 7.25 3.25002C7.25 2.8344 6.91563 2.50002 6.5 2.50002H3Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_3256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ce25eb0be7ec84a143920a49dbff91bb.svg";
export { ForwardRef as ReactComponent };